





















































import { Vue, Component, Prop } from "vue-property-decorator";
const DEMO_INFO = [
  {
    model: "MobileNet",
    title: "MobileNet, trained on ImageNet",
    path: "mobilenet",
  },
  {
    model: "CDINet",
    title: "CDINet, trained on SPAQ",
    path: "cdinet",
  },
  {
    model: "SqueezeNet",
    title: "SqueezeNet, trained on ImageNet",
    path: "squeezenet",
  },
  {
    model: "Emotion FerPlus",
    title: "Emotion FerPlus",
    path: "emotion_ferplus",
  },
  { model: "Yolo", title: "Yolo", path: "yolo" },
  { model: "MNIST", title: "MNIST", path: "mnist" },
];

@Component
export default class MainMenu extends Vue {
  @Prop({ default: "home" }) currentView: string;
  demoInfo: Array<{ model: string; title: string; path: string }> = DEMO_INFO;
  constructor() {
    super();
    this.demoInfo = DEMO_INFO;
  }
}
